<template>
  <div id="app">
    <!-- <div class="banner">
    </div> -->
    <div class="header">
      <div class="header__title">SHIN ANDO</div>
      <div class="header__nav">
        <a href="/#/about" class="header__nav__link">ABOUT</a>
        <a href="/#/works" class="header__nav__link">WORKS</a>
        <!-- <a href="/#/milestones" class="header__nav__link">MILESTONES</a> -->
      </div>
    </div>
    <transition name="fade">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="scss">
$black: #2c3e50;
body {
  margin: 0;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $black;
  margin-top: 60px;
}
.banner {
  background-image: url(./assets/header2.jpg);
  background-size: cover;
  width: calc(100% + 16px);
  position: relative;
  left: -8px;
  top: -60px;
  margin-bottom: -60px;
  height: 300px;
  background-position-y: -320px;
}
.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: .25s;
}

.fade-enter-active {
  transition-delay: .25s;
}

.fade-enter, .fade-leave-active {
  opacity: 0
}
.header {
  margin-bottom: 70px;
  &__nav {
    width: 30%;
    margin: auto;
    text-align: center;
    height: 30px;
      &__link {
        display: block;
        float: left;
        line-height: 30px;
        font-size: 16px;
        width: calc(100% / 2);
        color: $black;
        text-decoration: none;
        transition: .5s;
        &:hover{
          opacity: .6;
          text-decoration: underline;
        }
      }
  }
  &__title {
    font-size: 72px;
    text-align: center;
    font-weight: bold;
    line-height: 150px;
  }
}

@media screen and (max-width: 767px) {
  #app {
    margin-top: 20px;
  }
  .header {
    margin-bottom: 0;
    &__title {
      font-size: 42px;
    }
    &__nav {
      width: 90%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?c549467a